export const environment = {
  production: false,
  url:'https://recycle-api.intelvalia.net/api/',
  cryptoKey:'DEVCORPTvbsn)NqAa95^3Ud',
  menuGardienVisible : true,
  GoogleMapApiKey : 'AIzaSyBzUas_w6hqJ20KjCOCazpW8FoTDk35wAg',
};
